import React from 'react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button, Form, Input, Select, Alert } from 'antd';

import formatName from './formatName';
import initialControls from './initialControls';
import Control from './Control';
import AddControl from './AddControl';

import './styles.scss';

export const KEY_NEW = 'new';
export const KEY_COPY = 'copy-';

const validate = ({ label, category, controls }) => {
  const errors = {};

  if (!label) {
    errors.label = true;
  }

  if (!category) {
    errors.category = true;
  }

  if (!controls.length) {
    errors.controls = true;
  }

  return Object.keys(errors).length
    ? errors
    : true;
};

const isCopy = key => key.match(KEY_COPY);
const isNew = key => key === KEY_NEW;

const FormItem = Form.Item;

export class ActivityEdit extends React.Component {
  state = {
    activity: {
      label: '',
      category: '',
      controls: initialControls,
    },
    errors: {},
  };

  componentDidMount () {
    this.loadActivity();
  }

  componentDidUpdate ({ activity: prevActivity }) {
    const { activity } = this.props;
    if (activity !== prevActivity) {
      this.loadActivity();
    }
  }

  setName = ({ target: { value: label } }) => this.setState(({
    activity,
    ...state
  }) => ({
    ...state,
    activity: {
      ...activity,
      label,
    },
  }));

  setCategory = category => this.setState(({
    activity,
    ...state
  }) => ({
    ...state,
    activity: {
      ...activity,
      category,
    },
  }))

  onRemove = name => {
    const { activity, activity: { controls } } = this.state;
    const pos = controls.findIndex(({ name: cName }) => cName === name);

    if (pos === -1) return;

    if (controls[pos].mandatory) return;

    const newControls = [...controls];

    newControls.splice(pos, 1);

    this.setState({ activity: {
      ...activity,
      controls: newControls,
    } });
  }

  add = position => control => {
    const { activity: { controls } } = this.state;
    const newControls = [...controls];

    newControls.splice(position, 0, control);
    this.setState(state => ({
      ...state,
      activity: {
        ...state.activity,
        controls: newControls,
      },
    }));
  }

  onSave = pos => control => {
    const { activity: { controls: prevControls } } = this.state;
    const controls = [...prevControls];
    controls.splice(pos, 1, control);
    this.setState(({ activity, ...state }) => ({
      ...state,
      activity: {
        ...activity,
        controls,
      },
    }));
  }

  onDeleteForm = () => {
    const {
      match: { path },
      history: { replace },
      deleteForm,
    } = this.props;
    deleteForm();
    replace(path.replace('/:key', ''));
  }

  onPublish = async e => {
    e.preventDefault();

    const {
      publish,
      match: { params: { key: keyParam }, path },
      history: { replace },
    } = this.props;
    const { activity } = this.state;
    const valid = validate(activity);

    if (valid !== true) {
      this.setState({ errors: valid });
      return;
    }

    this.setState({ errors: {}, saving: true });

    const key = (keyParam === KEY_NEW || isCopy(keyParam))
      ? formatName(activity.label)
      : keyParam;

    await publish(key, activity);

    replace(path.replace('/:key', ''));

    this.setState({ saving: false });
  }

  loadActivity () {
    const { activity } = this.props;
    if (!activity) return;
    activity.controls = activity.controls || initialControls;
    this.setState({ activity });
  }

  render () {
    const { categories = [], t, match: { path, params: { key } } } = this.props;
    const {
      activity: { label, category, controls },
      errors: { label: errorLabel, category: errorCategory },
      saving,
    } = this.state;
    const { onRemove, onSave, onPublish, setName, setCategory, onDeleteForm } = this;
    const backPath = path.replace(/:key/, '');
    const isEdit = !isCopy(key) && !isNew(key);

    return (
      <form className="edit-activity activity" onSubmit={onPublish}>
        <Link
          to={backPath}
          className="ant-btn ant-btn-primary"
        >
          &lt; Retour à la liste
        </Link>
        <h2 className="edit-activity__title">
          {isEdit ? 'Modifier une activité' : 'Créer une nouvelle activité'}
        </h2>
        <FormItem
          label="Nom de l'activité"
          required
          validateStatus={errorLabel ? 'error' : null}
          help={errorLabel && <p>Le label est requis</p>}
        >
          <Input
            value={label}
            onChange={setName}
          />
        </FormItem>

        <FormItem
          label="Catégorie d'activité"
          required
          validateStatus={errorCategory ? 'error' : null}
          help={errorCategory && <p>La catégorie est requise</p>}
        >
          <Select value={category} onChange={setCategory}>
            {categories.map(value => (
              <Select.Option
                key={value}
                value={value}
              >
                {t('activity.category.label', { context: value })}
              </Select.Option>
            ))}
          </Select>
        </FormItem>

        <AddControl onAdd={this.add(0)} controls={controls} />
        {controls.map((control, k) => (
          <React.Fragment key={`${control.type}${control.name}`}>
            <Control
              control={control}
              controls={controls}
              onRemove={onRemove}
              onSave={onSave(k)}
            />
            <AddControl onAdd={this.add(k + 1)} controls={controls} />
          </React.Fragment>
        ))}

        <div className="edit-activity__footer">
          <p>En ajoutant cette activité, elle apparaitra dans la liste pour les usagers.</p>
          {(errorLabel || errorCategory) && (
            <Alert
              type="error"
              message={(
                <React.Fragment>
                  {errorLabel && <p>Le label est requis</p>}
                  {errorCategory && <p>La catégorie est requise</p>}
                </React.Fragment>
              )}
            />
          )}
          <Button
            type="primary"
            htmlType="submit"
            disabled={saving}
          >
            Sauvegarde
          </Button>
          {isEdit && (
            <Button
              className="edit-activity__delete"
              onClick={onDeleteForm}
            >
              Supprimer le formulaire de manière irréversible
            </Button>
          )}
        </div>
      </form>
    );
  }
}

export default translate()(ActivityEdit);



// WEBPACK FOOTER //
// ./src/components/Admin/ActivitiesManagement/ActivityEdit/ActivityEdit.js